import { StoreLogoSize, StoreLogoVariant } from './StoreLogo.types';

export const getLogoDimension = (size: StoreLogoSize): number => {
  switch (size) {
    case 'extraLarge':
      return 72;
    case 'large':
      return 64;
    case 'medium':
      return 48;
    case 'small':
      return 40;
    case 'extraSmall':
      return 32;
    default:
      return getLogoDimension('large');
  }
};

export const getPlaceholderDimension = (size: StoreLogoSize): number => {
  switch (size) {
    case 'extraLarge':
      return 36;
    case 'large':
      return 30;
    case 'medium':
      return 24;
    case 'small':
      return 18;
    case 'extraSmall':
      return 12;
    default:
      return getPlaceholderDimension('large');
  }
};
export const getBorderRadius = (variant: StoreLogoVariant): number => {
  switch (variant) {
    case 'circle':
      return 100;
    case 'square':
      return 10;
    default:
      return getBorderRadius('circle');
  }
};
